export class TabSettings {
    private view: 'simple_view' | 'detailed_view' | 'physical_relationships_view' | 'logical_relationships_view';

    constructor() {
        this.view = 'detailed_view'
    }
}